import { Config } from './config.type'
const config: Config  = {
    "build": {
        "host": "https://graphql.canvasflow.io",
        "subdirectory": "/",
        "website": "https://padi.com",
        "subscriptionUrl": "",
        "assetDirectory": "/",
        "title": "Scuba Diving",
        "shortTitle": "Scuba Diving",
        "appKey": "4570727f-b918-4d58-b98c-55beb37c8452",
        "language": "en",
        "languages": [
            "en"
        ],
        "links": {
            "invalidAuthenticationUrl": "https://store.padi.com/en-us/padi-club/?lang=en"
        },
        "buildNumber": 757659,
        "buildDate": "2025-06-06T13:30:26.581Z",
        "version": "2.10.6"
    },
    "app": {
        "contentProtection": false,
        "admin": true,
        "favorite": false,
        "auth": {
            "enabled": true,
            "type": "date-token",
            "config": {
                "multiplier": 7
            }
        },
        "hideNavbarOnScroll": false,
        "installationOption": {
            "enabled": false
        },
        "password": {
            "enabled": false,
            "value": ""
        },
        "template": {
            "type": "padi",
            "config": {
                "clientId": "48ul477uklf3k45b2uri89jti2",
                "verificationUrl": "https://piccoloapi-np.scubadiving.com/offer/recommendation",
                "auth": {
                    "enabled": false,
                    "type": "time",
                    "config": {
                        "reminderTime": 300,
                        "hardStopTime": 600,
                        "signUpUrl": "https://store.padi.com/en-us/subscription/scuba-diving-magazine-digital-subscription/p/60579-1B2C/",
                        "signInUrl": "https://account.padi.com/login/sign-in"
                    }
                }
            }
        },
        "legal": {}
    },
    "issue": {
        "contentType": "responsive-replica",
        "lastLocation": {
            "enabled": false
        }
    },
    "analytics": {
        "tealium": {
            "ChannelID": "",
            "pageType": "",
            "pageDetail": "",
            "pageTemplate": "",
            "projectType": "",
            "url": ""
        },
        "google": {
            "trackerID": "",
            "sampleRate": 1
        },
        "ga4": {
            "trackerID": "",
            "sampleRate": 1
        },
        "gtm": {
            "trackerID": ""
        },
        "gtag": {
            "trackerID": ""
        },
        "googleOptimize": {
            "trackerID": ""
        },
        "onetrust": {
            "id": ""
        },
        "caymland": {
            "domain": ""
        },
        "ackee": {
            "domainId": "",
            "server": ""
        },
        "netstats": {
            "trackerID": ""
        },
        "hotjar": {
            "trackerID": ""
        },
        "hubspot": {
            "trackerID": ""
        },
        "ShareThis": {
            "trackerID": ""
        },
        "cookiefirst": {
            "key": ""
        },
        "cookiehub": {
            "trackerID": ""
        },
        "plausible": {
            "domain": ""
        },
        "matomo": {
            "domain": ""
        }
    }
};
export default config;